export const FIELDS_EDITABILITY_SET = 'at/panels/user/authorizationInfo/FIELDS_EDITABILITY_SET'
export const CAN_EDIT_ENTIRE_USER_SET = 'at/panels/user/authorizationInfo/CAN_EDIT_ENTIRE_USER_SET'


// WEBPACK FOOTER //
// ./web/js/panels/user/authorizationInfo/actionTypes.js